import React from 'react';
export function ForWho() {
  return <section className="bg-crema py-10 sm:py-16 px-5" data-id="element-136">
      <div className="max-w-[860px] mx-auto" data-id="element-137">
        <div className="text-center mb-8 sm:mb-12" data-id="element-138">
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-3 text-oscuro uppercase" data-id="element-139">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-[15px] text-gris" data-id="element-140">
            Diseñado para vos si querés llevar tu negocio de estética al próximo
            nivel
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4" data-id="element-141">
          <div className="bg-white rounded-xl p-5 shadow-[0_3px_16px_rgba(0,0,0,0.07)] border-t-[3px] border-rosa" data-id="element-142">
            <div className="text-[24px] mb-2.5" data-id="element-143">💼</div>
            <strong className="block text-[14px] font-bold mb-1.5 text-oscuro" data-id="element-144">
              Esteticistas que improvisan
            </strong>
            <p className="text-[13px] text-gris leading-relaxed" data-id="element-145">
              Respondés precios por chat, no tenés documentos y querés una
              imagen acorde al nivel de tu trabajo.
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-[0_3px_16px_rgba(0,0,0,0.07)] border-t-[3px] border-rosa" data-id="element-146">
            <div className="text-[24px] mb-2.5" data-id="element-147">🏠</div>
            <strong className="block text-[14px] font-bold mb-1.5 text-oscuro" data-id="element-148">
              Trabajan solas o en pequeño centro
            </strong>
            <p className="text-[13px] text-gris leading-relaxed" data-id="element-149">
              No tenés equipo de marketing ni diseñadora. Con el kit lo resolvés
              todo vos misma en minutos.
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-[0_3px_16px_rgba(0,0,0,0.07)] border-t-[3px] border-rosa" data-id="element-150">
            <div className="text-[24px] mb-2.5" data-id="element-151">📈</div>
            <strong className="block text-[14px] font-bold mb-1.5 text-oscuro" data-id="element-152">
              Quieren subir precios
            </strong>
            <p className="text-[13px] text-gris leading-relaxed" data-id="element-153">
              Sabés que cobrás menos de lo que valés pero no tenés el método ni
              el mensaje para hacerlo.
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-[0_3px_16px_rgba(0,0,0,0.07)] border-t-[3px] border-rosa" data-id="element-154">
            <div className="text-[24px] mb-2.5" data-id="element-155">📲</div>
            <strong className="block text-[14px] font-bold mb-1.5 text-oscuro" data-id="element-156">
              Sin estrategia de redes
            </strong>
            <p className="text-[13px] text-gris leading-relaxed" data-id="element-157">
              Tenés Instagram pero publicás sin plan. Querés que las redes te
              traigan clientas sin depender de publicidad paga.
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-[0_3px_16px_rgba(0,0,0,0.07)] border-t-[3px] border-rosa sm:col-span-2 md:col-span-1" data-id="element-158">
            <div className="text-[24px] mb-2.5" data-id="element-159">✨</div>
            <span className="inline-block bg-dorado text-[#1A1A1A] text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md mb-2" data-id="element-160">
              Para vos también
            </span>
            <strong className="block text-[14px] font-bold mb-1.5 text-oscuro" data-id="element-161">
              Esteticistas con cartera armada
            </strong>
            <p className="text-[13px] text-gris leading-relaxed" data-id="element-162">
              Ya tenés clientas pero querés fidelizarlas mejor y hacer crecer
              tus ingresos sin trabajar más horas.
            </p>
          </div>
        </div>

        <p className="text-center mt-6 sm:mt-8 text-[14px] text-gris" data-id="element-163">
          ¿No estás segura si es para vos? Tenés 7 días de garantía →
        </p>
      </div>
    </section>;
}